
/// Asked before a channel is turned on: two entities of the same type and
/// environment must not cover the same one. Returns the entity already holding
/// it, or null when the channel is free.
interface PaymentEntityCellDelegate
{
    entityCoveringScope ( entity:PaymentEntity, scope:PaymentEntityScope ) : PaymentEntity;
}

class PaymentEntityCell extends UITableViewCell
{
    delegate:PaymentEntityCellDelegate = null;

    private nameTextField:MUITextField = null;
    private typeLabel:MUILabel = null;
    private environmentLabel:MUILabel = null;
    private orderTextField:MUITextField = null;

    private scopeButtons:{ scope:PaymentEntityScope, button:MUISwitchButton }[] = [];

    awakeFromHTML(){
        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnChangeText(this, function(textField:MUITextField, value:string) {
            this._item.name = value;
        });

        this.typeLabel = MUIOutlet(this, "type-lbl", "MUILabel");
        this.environmentLabel = MUIOutlet(this, "environment-lbl", "MUILabel");

        this.orderTextField = MUIOutlet(this, "order-tf", "MUITextField");
        if (this.orderTextField) this.orderTextField.setOnChangeText(this, function(this:PaymentEntityCell, textField:MUITextField, value:string) {
            let order = parseInt(value);
            this._item.orderIndex = isNaN(order) ? 0 : order;
        });

        this.setupScopeButton("scope-manager-btn", PaymentEntityScope.manager);
        this.setupScopeButton("scope-pos-btn", PaymentEntityScope.pos);
        this.setupScopeButton("scope-online-btn", PaymentEntityScope.online);
        this.setupScopeButton("scope-taptopay-btn", PaymentEntityScope.tapToPay);

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    protected _item:PaymentEntity = null;
    setItem(item:PaymentEntity){
        this._item = item;
        this.nameTextField.text = item.name;
        if (this.typeLabel) {
            let type_string = PaymentEntity.typeStringForType(item.type);
            this.typeLabel.text =  (item instanceof ProxyPaymentEntity) ? "Proxy:" +  type_string : type_string;
        }

        if (this.environmentLabel) {
            this.environmentLabel.text = (item.environment || "").toUpperCase();
            // A test entity charges nothing real — worth seeing at a glance.
            MUICoreLayerRemoveStyle( this.environmentLabel.layer, "alert" );
            if (item.environment != null && item.environment.toLowerCase() != "live") {
                MUICoreLayerAddStyle( this.environmentLabel.layer, "alert" );
            }
        }

        if (this.orderTextField) this.orderTextField.text = String(item.orderIndex ?? 0);

        for (let entry of this.scopeButtons) {
            entry.button.on = item.hasScope(entry.scope);
        }
    }

    set item(item:PaymentEntity) {
        this.setItem(item);
    }

    private setupScopeButton(outlet:string, scope:PaymentEntityScope) {
        let button = MUIOutlet(this, outlet, "MUISwitchButton") as MUISwitchButton;
        if (button == null) return;

        button.setOnChangeValue(this, function(this:PaymentEntityCell, control:MUISwitchButton, value:boolean){
            this.setScope(scope, value, control);
        });

        this.scopeButtons.push({ scope: scope, button: button });
    }

    private setScope(scope:PaymentEntityScope, on:boolean, control:MUISwitchButton) {
        // Turning a channel ON is the one direction that can clash; turning it
        // off always frees it.
        if (on == true && this.delegate != null) {
            let conflict = this.delegate.entityCoveringScope(this._item, scope);
            if (conflict != null) {
                control.on = false;
                AppHelper.showErrorMessage(null
                    , MIOLocalizeString("UNABLE_TO_ENABLE", "UNABLE TO ENABLE")
                    , conflict.name + " " + MIOLocalizeString("ALREADY_COVERS", "already covers") + " "
                      + PaymentEntity.scopeStringForScope(scope) + " "
                      + MIOLocalizeString("FOR_THIS_ENVIRONMENT_TURN_IT_OFF_THERE_FIRST", "for this environment. Turn it off there first."));
                return;
            }
        }

        this._item.setScope(scope, on);
    }
}
